import { HeaderHeightContext } from '@react-navigation/elements';
import { useNavigation } from '@react-navigation/native';
import React, { useEffect, useState } from 'react';
import { LayoutChangeEvent, LayoutRectangle } from 'react-native';
import { RootNavProps } from 'types/navigation';
import { setDynamicModalHeight } from 'utils/navigationUtils';

const useDynamicSheetSize = (bottomThreshold: number = 0) => {
  const [layout, setLayout] = useState<LayoutRectangle>();
  const headerHeight = React.useContext(HeaderHeightContext) ?? 0;
  const navigation = useNavigation<RootNavProps>();

  const handleLayout = (e: LayoutChangeEvent | LayoutRectangle) => {
    const layoutFromEvent = 'nativeEvent' in e ? e.nativeEvent.layout : e;
    setLayout(layoutFromEvent);
  };

  useEffect(() => {
    if (layout && headerHeight) {
      setDynamicModalHeight(
        { ...layout, height: layout.height + bottomThreshold },
        navigation,
        headerHeight
      );
    }
  }, [headerHeight, layout, navigation, bottomThreshold]);

  return { handleLayout };
};

export default useDynamicSheetSize;
